import { IProperty } from '../../data/entities/property';
import { IPropertySummary } from '../../data/entities/property-summary';

enum PropertyVerification {
	VERIFIED = 'VERIFIED',
	UNVERIFIED = 'UNVERIFIED',
	NO_DECISION = 'NO_DECISION',
}

/**
 * The purpose of this function is to determine which mode a property should enter TBP with.
 * @param onboardingIncomplete boolean determined by the result of `has_ever_published` of all customer's properties.
 * See `customerIsComplete`.
 * @param property IPropertySummary object
 * @returns {string}
 */
export const getTbpModeForCustomerAndProperty = (onboardingIncomplete: boolean, property: IPropertySummary): string => {
	if (property.has_ever_published) return 'edit';
	if (!property.has_ever_published) {
		if (onboardingIncomplete) return 'onboard';
		return 'add';
	}
	return 'onboard';
};

export const isPropertyPublishedAndVerified = (property?: IProperty | IPropertySummary) =>
	Boolean(property?.published_at) &&
	property?.verification_status === PropertyVerification.VERIFIED;

/*
 * Returns true if one of the properties is published and verified
 * This is commonly used to identify if the user has just come out of onboarding
 */
export const hasAtLeastOnePublishedAndVerifiedProperty = (
	properties?: IProperty[] | IPropertySummary[],
) =>
	Boolean(
		properties &&
			properties.some((property) =>
				isPropertyPublishedAndVerified(property),
			),
	);
